import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import style from '../pendingApproval/pending.module.css'
import css from './consultation.module.css'
import BoxComponent from '../ReuseComponent/BoxComponent'
import CardComponent from '../ReuseComponent/CardComponent'
import { database } from '../../utils/firebase'
import { path } from '../../utils/const'
import BackComponent from '../../components/BackComponent/BackComponent'

let activeListener = null
const ActiveConsultationPage = () => {
  const [activeConsultation, setActiveConsultation] = useState([])
  const [activeReadConsultation, setActiveReadConsultation] = useState([])
  const [activeUnReadConsultation, setActiveUnReadConsultation] = useState([])
  const [activeCount, setActiveCount] = useState(0)
  const [searchValue, setSearchValue] = useState('')

  const me = useSelector((state) => state.app.me)

  const searchfunction = async (name) => {

    const filteredConsultations = activeConsultation.filter((item) => {
      let pName = item?.patientName || "";

      return pName.toLowerCase().includes(name.toLowerCase())
    });

    setActiveReadConsultation(
      filteredConsultations.filter((convo) => !convo.unReadCount),
    )
    setActiveUnReadConsultation(
      filteredConsultations.filter((convo) => convo.unReadCount),
    )
  };
  useEffect( () => {

    activeListener = database
      .ref(`/delegateChats`)
      .orderByChild('status')
      .equalTo('active')
    activeListener.on('value', (openSnapshot) => {

      const activeConsultationJSON = openSnapshot.toJSON() || {}
      let activeConsultationData = Object.keys(activeConsultationJSON)
      activeConsultationData = activeConsultationData.map((key) => {
        return { ...activeConsultationJSON[key], id: key }
      })
      if (me.role === 'Doctor') {
        activeConsultationData = activeConsultationData.filter(
          (convo) => convo.doctorID === me.id,
        )
      }
      
      activeConsultationData = activeConsultationData.sort((a, b) => {
        return (b.timestamp || 0) - (a.timestamp || 0);
      })
      setActiveReadConsultation(
        activeConsultationData.filter((convo) => !convo.unReadCount),
      )
      setActiveUnReadConsultation(
        activeConsultationData.filter((convo) => convo.unReadCount),
      )
      setActiveConsultation(activeConsultationData)
      setActiveCount(activeConsultationData.length)
    })
    return () => {
      if (activeListener) {
        activeListener.off()
        activeListener = null
      }
    }

  }, [])
  return (
    <div>
      <div className={style.pastScroll}>
        <BackComponent
          title={'Active consultations'}
          activeCount={activeCount}
          dashboard={path.dashboard}
        />
        <BoxComponent />
        <div className={style.line}></div>
        { <div className={style.searchDiv}>
          <input className={style.search} type="text" placeholder="Search patients" onChange={(event) => { setSearchValue(event.target.value) }} />
          <button className={style.searchButton} onClick={(event) =>searchfunction(searchValue)}>Search</button>
        </div> }
        <div className={style.line}></div>
        <div className={css.unreadMsg}>
          <span className={css.font}>Unread messages</span>
        </div>
        {activeUnReadConsultation.map((obj, i) => {
          return (
            <div className={css.UnreadPatient} key={obj.id}>
              <CardComponent
                forwardPath={path.ChatModule}
                archiveID={obj.id}
                delegateData={obj}
              />
            </div>
          )
        })}

        <div className={css.unreadMsg}>
          <span className={css.font}>Read messages</span>
        </div>
        {activeReadConsultation.map((obj) => {
          return (
            <div key={obj.id}>
              <CardComponent
                forwardPath={
                  obj.conversationID ? path.ChatModule : path.consultation
                }
                archiveID={obj.id}
                delegateData={obj}
              />
            </div>
          )
        })}
        <div className={style.bottomPadding}></div>
      </div>
    </div>
  )
}
export default ActiveConsultationPage
